import Cookies from 'universal-cookie';
import { API_HOST } from "../config";
import { API_ROUTE_CONTROLLER,API_VERBS } from "./route";
import axios from 'axios';

const cookies = new Cookies();

export class BaseService {
    token = () => {
    //  return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.EuayzjaKptK_mE6_xaMIGpLdE4e8P2WV7MjV1CdqM-U";

        let _token = ""
        if(typeof window!==undefined) {
          _token = cookies.get("ssoToken");
          if(!_token) {
            _token = API_HOST.appSecret;
          }
          return _token;
        }
   
    };
      
    get = async (_url) => {
        try {
          const requestOptions = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': this.token(),
            },
          };
          const response = await fetch(
            _url,
            requestOptions,
          );
          return await response.json();
        } catch (error) {
          console.log("Api error:", error);
        }
        return null;
    };

    post = async (_url, _body) => {
        try {
          const requestOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': this.token(),
            },
            body: JSON.stringify(_body),
          };
          const response = await fetch(
            _url,
            requestOptions,
          );
          return await response.json();
        } catch (error) {
          console.log("Api error:", error);
        }
        return null;
    };

    patch = async (_url, _body) => {
      try {
        const requestOptions = {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token(),
            'x-access-token': this.token()
          },
          body: JSON.stringify(_body),
        };
        const response = await fetch(
          _url,
          requestOptions,
        );
        return await response.json();

       
      } catch (error) {
        console.log("Api error:", error);
      }
    };
    

    sso = async (_url, _body) => {
      try {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            appId: API_HOST.appId,
            appSecret: API_HOST.appSecret,
          },
          body: JSON.stringify(_body),
        };
        const response = await fetch(
          _url,
          requestOptions,
        );
        return await response.json();
      } catch (error) {
        console.log("Api error:", error);
      }
      return null;
    };

    getHtml = async (_url) => {
      try {
        const response = await fetch(
          _url
        );
        return await response.text();
      } catch (error) {
        console.log("Api error:", error);
      }
      return null;
    };

    getResponse = async(response)=>{
      let err_code = "";
      let message = "";
      let result = null;
      if(typeof response!="undefined" && response!=null) {
        /*
        if(typeof response.message!="undefined" && response.message!="") {
          message = response.message;
        }

        if(typeof response.err_code!="undefined" && response.err_code==1){
          err_code = response.err_code;
        } else if(typeof response.errCode!="undefined" && response.errCode==1) {
          err_code = response.errCode;
        }
        */
        if(typeof response.finalresponse!="undefined") {
          result = response.finalresponse;
        }
        else if(typeof response.finalResponse!="undefined") {
          result = response.finalResponse;
        }
        else if(typeof response.datas!="undefined") {
          result = response.datas;
        }
        else if(typeof response.result!="undefined") {
          result = response.result;
        } else if(typeof response.body!="undefined" && typeof response.body.results!="undefined") {
          return response.body.results;
        } else {
          if(response) {return response};
        }
      }
      return result;
    };

    hubspot = async (_body, _action, _id, method = "") => {
      let _url = "https://api.hubapi.com/crm/v3/objects/" + _action + "/" + _id;
      let _method = 'PATCH';
      if (method != "") _method = method;
    
      if (_action == "associations") {
        _method = 'PUT';
        _url = "https://api.hubapi.com/crm-associations/v1/" + _action + "/" + _id;
      } else if (_action == "companies") {
        //_method = 'DELETE';
        _url = "https://api.hubapi.com/crm/v3/objects/companies/" + _id;
      }else if (_action == "contacts") {
        _url = "https://api.hubapi.com/crm/v3/objects/contacts/" + _id;
      } else {
        if (_action == "delete") {
          //_method = 'DELETE';
          _url = "https://api.hubapi.com/contacts/v1/contact/vid/" + _id;
        } else {
    
        }
      }
    
      try {
        const requestOptionsNew = {
          method: "POST",
          header: {
            "accept": "application/json",
            "content-type": "application/json"
          },
          body: JSON.stringify({
            method: _method,
            url: _url,
            properties: {
              properties: _body
            }
          })
        }
        const url = API_ROUTE_CONTROLLER.hubspot_api
        const response = await fetch(
          url, requestOptionsNew
        )
    
        const jsonResp = await response.json();
        if (jsonResp != null) {
          return jsonResp;
        } else {
          return null;
        }
      } catch {
        return null;
      }
    };

    upload = async(file)=>{
      const formData = new FormData();
      formData.append('files',  file);
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };
      return await axios.post(API_ROUTE_CONTROLLER.file_upload, formData, config).then((response) => {
        if(response && response.data && response.data.filepath) {
          return response.data.filepath;
        }
        return null;
      });
  
    };
   
      
}